
// 선택하게 될 5지 선다 각 5 25 50 75 95점
const checkAnswer = {
    1: '확실히 아니다.',
    2: '아마도 아닐 거다.',
    3: '보통이다.',
    4: '조금 맞는 것 같다.',
    5: '확실히 맞다.',
}
export default checkAnswer